export enum FinancialStatus {
    Paid = 1,
    Unpaid = 2,
}